// Started from shadcn/ui (new-york-v4) "checkbox", restyled to Union. Always with a Label;
// on touch screens the label is the 44px target.

import { cn } from "@union/ui/lib/utils";
import { CheckIcon, MinusIcon } from "lucide-react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import type * as React from "react";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-5 shrink-0 rounded-[calc(var(--radius-sm)/2)] border-[1.5px] border-input bg-card transition-colors duration-150",
        "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        // Some, not all (a "select every row" box): a dash, so it never reads as all.
        "data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground",
        "disabled:cursor-not-allowed disabled:border-border disabled:bg-muted",
        "aria-invalid:border-destructive",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="group grid place-content-center">
        <CheckIcon className="size-4 group-data-[state=indeterminate]:hidden" strokeWidth={2.5} />
        <MinusIcon className="hidden size-4 group-data-[state=indeterminate]:block" strokeWidth={2.5} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
